













































import { Component, Mixins } from "vue-property-decorator";
import CProdInjectorMixin from "@/mixins/cProdInjectorMixin";
import { PriceType } from "@/data/enums/contractProducts";

@Component
export default class CProdPriceTaxSummary extends Mixins(CProdInjectorMixin) {
  // Computed

  public get cProd() {
    return this.cProdData.contractProduct;
  }

  public get brandCurrencyCode() {
    return this.cProdData.contract?.brand?.currency?.code;
  }

  public get taxSummary() {
    if (this.cProdData.isSubscription) return null;
    return this.$store.getters["brand/taxSummary"]({
      taxType: this.cProdData.contract.brand.tax_type,
      taxAmount: this.cProd.tax_amount,
      taxIncPrice: this.cProd.configuration_total_amount_formatted,
      taxExcPrice: this.cProd.configuration_net_amount_formatted
    });
  }

  public get recurringTaxSummary() {
    if (!this.cProdData.isSubscription) return null;
    return this.$store.getters["brand/taxSummary"]({
      taxType: this.cProdData.contract.brand.tax_type,
      taxAmount: this.cProd.tax_amount,
      taxIncPrice: this.cProd.configuration_total_recurring_amount_formatted,
      taxExcPrice: this.cProd.configuration_total_recurring_net_amount_formatted
    });
  }

  // Methods

  public isConvertedPrice(type: PriceType | null) {
    return type === PriceType.CONVERTED;
  }

  public isManualPrice(type: PriceType | null) {
    return type === PriceType.MANUAL;
  }
}
